var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00976562H513V341.994H0V-0.00976562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00976562H513V90.7461H0V-0.00976562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 251.238H513V341.983H0V251.238Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 113.486H513V228.51H0V113.486Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.896 54.5684L298.263 42.7363L256.5 137.303L214.736 42.7363L189.104 54.5684L240.954 170.986L189.104 287.405L214.736 299.236L256.5 204.671L298.263 299.236L323.896 287.405L272.046 170.986L323.896 54.5684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.91 65.7181C263.986 54.881 256.5 48.6519 256.5 48.6519C256.5 48.6519 249.013 54.88 239.09 65.7171V276.255C249.013 287.092 256.5 293.322 256.5 293.322C256.5 293.322 263.986 287.094 273.91 276.256V65.7181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.448 106.092V235.88C219.934 254.458 232.768 269.688 242.384 279.784V62.1885C232.767 72.2842 219.933 87.5128 209.448 106.092ZM303.552 106.092C293.066 87.5128 280.232 72.2842 270.615 62.1885V279.785C280.233 269.688 293.066 254.459 303.552 235.881V106.092Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.552 106.092V235.88C314.167 217.069 322.372 194.827 322.372 170.986C322.372 147.146 314.167 124.903 303.552 106.092ZM209.448 106.092V235.88C198.834 217.069 190.628 194.827 190.628 170.986C190.628 147.146 198.834 124.903 209.448 106.092Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.0078125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKe);
export default __webpack_public_path__ + "static/media/KE.6592e95694a94985c712e5ceea0c369d.svg";
export { ForwardRef as ReactComponent };